module.exports = __webpack_public_path__ + "img/example-test.de607541.png";